import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  Row,
  Col,
  Label,
  Card,
} from "reactstrap";
import i18n from "../../../i18n";
import { map } from "lodash";
import { getCostCentersReports } from "../../../helpers/api_rombo_helper";
import { getCurrentDate } from "../../../helpers/format_dates";
import { saveAs } from "file-saver";
import Select from "react-select";

const DownloadReportsModal = ({ isOpen, toggle, setShowAlertSuccess, setDownloadReportsModal, checkCostCenter, setTextHeader, setTextBody, token }) => {

  const [selectFileType, setSelectFileType] = useState(null);
  const [ids, setIds] = useState("");

  useEffect(() => {
    var n_ids = ids
    map(checkCostCenter, (costCenter, key) => {
      n_ids = n_ids.length === 0 ? costCenter.id : n_ids
      !n_ids.split(",").includes(costCenter.id) ? n_ids+=`,${costCenter.id}` : n_ids
      setIds(n_ids)
    })
  }, [checkCostCenter]);

  const downloadReport = () => {
    getCostCentersReports(token, ids, selectFileType?.value)
      .then((response) => {
        var file = new File([response], `Reports1-${getCurrentDate("-")}.zip`); 
        saveAs(file, `Reports2-${getCurrentDate("-")}.zip`);
        setShowAlertSuccess(true)
        setDownloadReportsModal(false)
        setTextHeader(i18n.t("DownloadedReport"))
        setTextBody(i18n.t("SuccessDownloadReportMultiple", { format: selectFileType?.label }))
      })
      .catch((error) => {
        console.error("Error - getCostCentersReports ", error);
        setErrorAlert(true)
        setErrorAlertMessage((error.response?.data?.detail || error.message))
      })
  }
  
  const handleSelectTypeFile = (select) => {
    setSelectFileType(select)
  }

  const str2bytes = (str) => {
    var bytes = new Uint8Array(str.length);
    for (var i=0; i<str.length; i++) {
       bytes[i] = str.charCodeAt(i);
     }
     return bytes;
  }

  const onClicklCancel = () => {
    setDownloadReportsModal(false)
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"lg"}
    >
      <div>
        <p className="cancellation-title">{i18n.t("DownloadReport")}</p>
        <p className="cancellation-confirmation">{i18n.t("SelectFileType")}</p>
        <div className="modal-separator"></div>
        <ModalBody className="mt-0 pt-0">
          <Row>
            <Form className="row gy-2 gx-3 align-items-center">
              <Col xxl={12} md={12} xs={12}>
                <div className="mb-3">
                  <p className="cancellation-reason">{i18n.t("CostCenter")}:</p>
                  {map(checkCostCenter, (costCenter, key) => (
                    <p className="cancellation-text" key={key}> - {costCenter.name}</p>
                  ))}
                  <Label className="cancellation-reason">{i18n.t("FileType")}</Label>
                  <p className="cancellation-text">{i18n.t("TextDownloadReport")}</p>
                  <Card>
                    <Select
                      placeholder={i18n.t("SelectFileType")}
                      onChange={(e) => {
                          handleSelectTypeFile(e);
                      }}
                      options={[{label: "XLSX", value: "XLSX"},{label: "CSV", value: "CSV"},{label: "PDF", value: "PDF"}]}
                      className="select2-selection"
                    />
                  </Card>
                </div>
              </Col>
            </Form>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-users border"
            type="button"
            onClick={downloadReport}
          >
            {i18n.t("Save")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={onClicklCancel}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

DownloadReportsModal.propTypes = {
  setShowAlertSuccess: PropTypes.func,
  setDownloadReportsModal: PropTypes.func,
  checkCostCenter: PropTypes.array,
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  token: PropTypes.object,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func
}

export default DownloadReportsModal;
